import tableDataDevelopment from "./variables/tableDataDevelopment";
import tableDataCheck from "./variables/tableDataCheck";
import CheckTable from "./components/CheckTable";
import tableDataColumns from "./variables/tableDataColumns";
import tableDataComplex from "./variables/tableDataComplex";
import DevelopmentTable from "./components/DevelopmentTable";
import ColumnsTable from "./components/ColumnsTable";
import ComplexTable from "./components/ComplexTable";

const Evaluacion = () => {
  return (
    <div>
      

      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
      <CheckTable tableData={tableDataCheck} />
      <ComplexTable tableData={tableDataComplex} />
      

        
      </div>
    </div>
  );
};

export default Evaluacion;
